import {isValidHttpUrl} from "./helpers";
import {EventPositions} from "./types";

let internalLinks: IInternalLinks|null = null;

export interface IInternalLinks {
  homeCompetitorPageLink?: string,
  homeSecondCompetitorPageLink?: string,
  awayCompetitorPageLink?: string,
  awaySecondCompetitorPageLink?: string,
}

// Validate InternalLinks. Input value can be Any type.
const validateInternalLinkFromJson = (internalLinksJson: any): IInternalLinks|null => {
  const internalLinks: IInternalLinks = JSON.parse(internalLinksJson);

  if (!internalLinks) {
    console.error('Widgets Error: Invalid JSON for internal links.')
    return null;
  }

  if (
    !internalLinks.homeCompetitorPageLink
    || typeof internalLinks.homeCompetitorPageLink !== 'string'
    || !isValidHttpUrl(internalLinks.homeCompetitorPageLink)
  ) {
    console.error('Widgets Error: Invalid JSON for internal links. Invalid "homeCompetitorPageLink" property.');
    return null;
  }

  if (
    !internalLinks.homeSecondCompetitorPageLink
    || typeof internalLinks.homeSecondCompetitorPageLink !== 'string'
    || !isValidHttpUrl(internalLinks.homeSecondCompetitorPageLink)
  ) {
    console.error('Widgets Error: Invalid JSON for internal links. Invalid "homeSecondCompetitorPageLink" property.');
    return null;
  }

  if (
    !internalLinks.awayCompetitorPageLink
    || typeof internalLinks.awayCompetitorPageLink !== 'string'
    || !isValidHttpUrl(internalLinks.awayCompetitorPageLink)
  ) {
    console.error('Widgets Error: Invalid JSON for internal links. Invalid "awayCompetitorPageLink" property.');
    return null;
  }

  if (
    !internalLinks.awaySecondCompetitorPageLink
    || typeof internalLinks.awaySecondCompetitorPageLink !== 'string'
    || !isValidHttpUrl(internalLinks.awaySecondCompetitorPageLink)
  ) {
    console.error('Widgets Error: Invalid JSON for internal links. Invalid "awaySecondCompetitorPageLink" property.');
    return null;
  }

  return internalLinks;
}

export const setUpInternalLinks = (InternalLinksJson: string): void => {
  try {
    const validatedInternalLinks: IInternalLinks|null = validateInternalLinkFromJson(InternalLinksJson);
    internalLinks = validatedInternalLinks ?? null;
  } catch (err) {
    console.error('Widgets Error: Wrong Internal links.');
    console.log(err);
    internalLinks = null;
  }
}

export const getInternalLinks = (): IInternalLinks|null => internalLinks;

export const getCompetitorInternalLinkByPosition = (eventPosition: EventPositions): string|undefined => {
  if (!internalLinks) {
    return undefined
  }

  if (eventPosition === EventPositions.home && internalLinks.homeCompetitorPageLink) {
    return internalLinks.homeCompetitorPageLink;
  }

  if (eventPosition === EventPositions.away && internalLinks.awayCompetitorPageLink) {
    return internalLinks.awayCompetitorPageLink;
  }

  return undefined;
}
